<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-10 18:12:08
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-01 11:16:27
 * @FilePath: \ioc_base\src\modules\buildingConfig\components\floor.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="floor-wrap">
    <div>
      <el-button type="primary" @click="addFloor" icon="el-icon-plus">
        新增
      </el-button>
    </div>
    <div class="floor-wrap__body">
      <el-table
        class="floor-table"
        :data="floorTable"
        height=" 100%"
        max-height="100%"
      >
        <el-table-column prop="date" label="平面图">
          <template v-slot="scope">
            <img
              v-if="!scope.row.state"
              class="floor-img"
              :src="imgPath(scope.row)"
              onerror="this.src='/images/theme/newDark/default.png'"
              @click="showViewer($event)"
            />
            <div v-else>
              <el-upload
                action="#"
                class="floor-img"
                v-if="!scope.row.fileList.length"
                :file-list="scope.row.fileList"
                :show-file-list="false"
                :list-type="'picture-card'"
                accept="image/png, image/jpg, image/jpeg, image/bpm"
                :auto-upload="false"
                :multiple="false"
                :limit="1"
                :on-change="
                  (file, fileList) => {
                    onChangeFile(file, fileList, scope.$index);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="floor-file" v-else>
                <img :src="queryImg(scope.row.fileList)" class="floor-img" />
                <!-- onerror="this.src='/images/theme/newDark/default.png'" -->
                <div class="delete-icon">
                  <i
                    class="el-icon-delete"
                    @click="onRemoveFile(scope.$index)"
                  ></i>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="buildingName" label="楼层名称" align="center">
          <template v-slot="scope">
            <div v-if="scope.row.state">
              <el-input v-model="scope.row.buildingName"></el-input>
            </div>
            <span v-else>
              {{ scope.row.buildingName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope">
            <div v-if="scope.row.state">
              <el-button
                @click="handleSave(scope.row, scope.$index)"
                type="text"
                size="small"
                icon="el-icon-document-checked"
                >保存</el-button
              >
              <el-button
                type="text"
                size="small"
                icon="el-icon-refresh-left"
                @click="handleCancel(scope.row, scope.$index)"
                >取消</el-button
              >
            </div>
            <div v-else>
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit-outline"
                @click="handleUpdate(scope.row, scope.$index)"
                >修改</el-button
              >
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="handleDelete(scope.row, scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import { api } from "../api";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      buildingInfo: {},
      viewerInstance: null,
      viewerPhotos: [],
      fileList: [],
      pageObj: {
        pageNum: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        total: 0,
      },
      floorTable: [
        // {
        //   date: "2016-05-02",
        //   name: "王小虎",
        //   address: "上海市普陀区金沙江路 1518 弄",
        //   //    state: "0",没有即查看状态，有这是编辑状态
        // },
      ],
    };
  },
  methods: {
    showViewer(e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    imgPath(item) {
      return item ? utils.Bus.imgPath(item.fileCode) : "";
    },
    getListData(info) {
      this.buildingInfo = info;
      let params = {
        pageNum: this.pageObj.pageNum,
        pageSize: 100, // this.pageObj.pageSize,
        buildingCode: info.buildingCode,
        pageFlag: true,
        buildingType: 2, //1楼栋2楼层
      };
      this.$fetch(api.queryBuildingList, params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.floorTable = res.returnObj.list;
          this.pageObj.total = res.returnObj.total;
        } else {
          this.floorTable = [];
          this.$message.error(res.msgContent);
        }
      });
    },
    addFloor() {
      if (
        this.floorTable[0] &&
        this.floorTable[this.floorTable.length - 1].state == 0
      ) {
        this.$message.warning("请将上一次数据保存后新增");
        return;
      }
      this.floorTable.push({
        state: "0",
        fileList: [],
      });
    },
    handleSave(info, index) {
      console.log(info);
      if (!info.buildingName) {
        this.$message.warning("请填写楼层名称");
        return;
      }
      if (info.fileList.length && info.fileList[0].name) {
        const formData = new FormData();
        info.fileList.map((item) => {
          formData.append("files", item.raw);
        });
        this.$fetch(api.upFile, formData).then((res) => {
          if (res.success) {
            info.fileCode = res.returnObj[0].fileId;
            this.submitData(info, index);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        this.submitData(info, index);
      }
    },
    submitData(info, index) {
      let params = {
        buildingName: info.buildingName,
        fileCode: info.fileCode,
        belongModelUrl: info.belongModelUrl,
        parentCode: this.buildingInfo.buildingCode,
      };
      let url = "";
      !info.buildingCode
        ? (url = api.addBuilding)
        : ((url = api.updateBuilding),
          (params.buildingCode = info.buildingCode));
      this.$fetch(url, params).then((res) => {
        this.subBtm = false;
        if (res.success) {
          this.$message.success("操作成功");
          if (info.buildingCode) {
            this.$set(
              this.floorTable[index],
              "buildingName",
              info.buildingName
            );
            this.$set(this.floorTable[index], "fileCode", info.fileCode);
            this.$set(this.floorTable[index], "state", "");
            delete this.floorTable[index].buildingNameCopy;
            delete this.floorTable[index].state;
            console.log(this.floorTable[index]);
          } else {
            this.$emit("update-callback");
            this.getListData(this.buildingInfo);
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleCancel(info, index) {
      if (info.buildingCode) {
        this.$set(
          this.floorTable[index],
          "buildingName",
          info.buildingNameCopy
        );
        this.$set(this.floorTable[index], "state", "");
        delete this.floorTable[index].buildingNameCopy;
        delete this.floorTable[index].state;
        // console.log(this.floorTable[index]);
      } else {
        this.floorTable.splice(index, 1);
      }
    },
    handleUpdate(info, index) {
      console.log(info);
      this.$set(this.floorTable[index], "state", "0");
      this.$set(
        this.floorTable[index],
        "fileList",
        info.fileCode ? [info.fileCode] : []
      );
      this.$set(this.floorTable[index], "buildingNameCopy", info.buildingName);

      //   console.log(this.floorTable[index]);
    },
    handleDelete(info, index) {
      this.$confirm("此操作将永久删除该数据, 是否继续？", "确认删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.$fetch(api.deleteBuilding, {
          buildingCode: info.buildingCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            this.floorTable.splice(index, 1);
            this.$emit("update-callback");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },

    onChangeFile(file, fileList, index) {
      if (!this.validImg(file)) {
        this.floorTable[index].fileList = [];
        return false;
      }
      this.floorTable[index].fileList = fileList;
    },
    onRemoveFile(index) {
      this.$confirm("确认要删除图片吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.floorTable[index].fileList = [];
      });
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    queryImg(fileList) {
      if (fileList[0] && fileList[0].name) {
        return URL.createObjectURL(fileList[0].raw);
      } else {
        return utils.Bus.imgPath(fileList[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .el-upload--picture-card {
  width: 60px !important;
  height: 50px !important;
  line-height: 65px;
}
:deep .el-table__body-wrapper {
  height: calc(100% - 30px) !important;
  max-height: calc(100% - 30px) !important;
}
.floor-wrap {
  height: 100%;
  position: relative;
  .floor-img {
    width: 60px;
    height: 50px;
    cursor: pointer;
  }
  &__body {
    height: calc(100% - 50px);
    .floor-table {
      width: 100%;
      padding: 16px;
      margin-top: 16px;
    }
  }
  .floor-file {
    display: flex;
    position: relative;
    @extend .floor-img;
    &:hover {
      .delete-icon {
        opacity: 1;
      }
    }
    .delete-icon {
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      @extend .floor-img;
      border-radius: 6px;
      opacity: 0;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0.4);
      transition: all 0.2s;
    }
  }
}
</style>
